'use client';

// @boty/ui - useDirection hook
// Provides access to current text direction from MUI theme

import { useTheme } from '@mui/material/styles';

/**
 * Hook to access the current text direction from the MUI theme
 *
 * @returns Object containing direction info:
 *   - direction: 'ltr' | 'rtl' - Current text direction
 *   - isRtl: boolean - True if direction is RTL
 *   - isLtr: boolean - True if direction is LTR
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { direction, isRtl, isLtr } = useDirection();
 *
 *   return (
 *     <div style={{ textAlign: isRtl ? 'right' : 'left' }}>
 *       Current direction: {direction}
 *     </div>
 *   );
 * }
 * ```
 */
export function useDirection() {
  const theme = useTheme();
  return {
    direction: theme.direction,
    isRtl: theme.direction === 'rtl',
    isLtr: theme.direction === 'ltr',
  };
}
